var map = {
	"./bg-exclusive.webp": 1291,
	"./border-bg-sm.png": 1292,
	"./border-bg-xm.png": 1293,
	"./border-bg.png": 1294,
	"./btn-active.png": 1295,
	"./casino-hover.webp": 1296,
	"./cny-flower-1.webp": 1297,
	"./cny-flower-2.webp": 1298,
	"./cny-mobile-bg.webp": 1299,
	"./content-deco-1.webp": 1300,
	"./content-deco-2.webp": 1301,
	"./content-deco-3.webp": 1302,
	"./content-deco-4.webp": 1303,
	"./content-deco-5.webp": 1304,
	"./deposit-icon.webp": 1305,
	"./event-border-hover.webp": 1306,
	"./games-hover.webp": 1307,
	"./home-icon-active.webp": 1308,
	"./home-icon.webp": 1309,
	"./live-icon-active.webp": 1310,
	"./live-icon.webp": 1311,
	"./lottery-hover.webp": 1312,
	"./master-bg.png": 1313,
	"./me-icon-active.webp": 1314,
	"./me-icon.webp": 1315,
	"./p2p-hover.webp": 1316,
	"./platform.webp": 1317,
	"./product-overview-bg.webp": 1318,
	"./promos-icon-active.webp": 1319,
	"./promos-icon.webp": 1320,
	"./slots-hover.webp": 1321,
	"./sponsor-icon-active.webp": 1322,
	"./sponsor-icon.webp": 1323,
	"./sports-hover.webp": 1324,
	"./title-deco-bg.webp": 1325,
	"./title-deco-left.webp": 1326,
	"./title-deco-right.webp": 1327,
	"./vip-icon-active.webp": 1328,
	"./vip-icon.webp": 1329,
	"./withdraw-icon.webp": 1330,
	"./wwr-bg.webp": 1331,
	"./wwr-img.webp": 1332
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 146;